<template>
  <AnimatedBackground>
    <CodeSection />
  </AnimatedBackground>
</template>

<script>
import CodeSection from '../components/CodeSection.vue';
import AnimatedBackground from '../components/AnimatedBackground.vue';

export default {
  name: 'CodePage',
  components: {
    CodeSection,
    AnimatedBackground
  }
}
</script>

<style scoped>
.code-page {
  min-height: 100vh;
  width: 100%;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
}
</style>
